import { IconProps } from '../types';
const IcMenuHide = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='17' viewBox='0 0 20 17' fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.7461 2.19483H-0.000953674V0H19.7461V2.19483ZM19.7461 9.32801L8.77551 9.32801V7.13319L19.7461 7.13319V9.32801ZM-0.000953674 16.4612L19.7461 16.4612V14.2664L-0.000953674 14.2664V16.4612ZM4.4509 4.93754C4.81588 4.7013 5.29743 4.96336 5.29743 5.39821V10.8371C5.29743 11.2719 4.81588 11.534 4.45091 11.2977L0.249582 8.57832C-0.0844669 8.36209 -0.0844669 7.87319 0.249582 7.65697L4.4509 4.93754Z'
      fill={props.fill ?? '#777D7C'}
    />
  </svg>
);

export default IcMenuHide;
